var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('b-container',{staticClass:"ombre"},[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"lg":"8","xl":"9"}},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.$t('stop.title'))}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('stop.md'))}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }